"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertToSyncContentChangeView = exports.buildSyncDescriptions = void 0;
const action = {
    add: 'added',
    delete: 'removed',
    update: 'updated',
};
const syncNotificationData = (content) => {
    return Object.entries(content).map(([type, actions]) => {
        const syncContentChanges = (0, exports.convertToSyncContentChangeView)(actions);
        return (0, exports.buildSyncDescriptions)(type, syncContentChanges);
    });
};
const buildSyncDescriptions = (contentType, actions) => {
    const type = contentType === 'plate' ? 'screen' : contentType;
    return Object.entries(actions).map(([syncAction, count]) => {
        const actionType = count > 1 ? `${type}_plural` : type;
        return [syncAction, count, actionType];
    });
};
exports.buildSyncDescriptions = buildSyncDescriptions;
const convertToSyncContentChangeView = (actions) => {
    return Object.entries(actions).reduce((acc, [key, ids]) => {
        if (action[key] && ids.length) {
            acc[action[key]] = ids.length;
        }
        return acc;
    }, {});
};
exports.convertToSyncContentChangeView = convertToSyncContentChangeView;
exports.default = syncNotificationData;
